import { IRootCategory, ICategory } from '../../../contract/category.contract';
import { searchApiService } from '../../../services/search-api.service';
import { LoadableList } from '../../../shared/BasicTypes';
import { TypedActionTree, TypedGetterTree, TypedMutationTree } from '../../CustomFundamentalStoreContracts';
import { IRootState } from '../../root/rootTypes';
import { VuexModuleFactory } from '../../VuexModuleFactory';
import { ISearchActions, ISearchGetters, ISearchMutations, ISearchState } from './searchTypes';
import { INamedGroup } from '../../../contract/named-group.contract';

const SearchMutations: TypedMutationTree<ISearchMutations, ISearchState> = {
  CLEAR_SEARCH_RESULTS: (state) => {
    state.pagedSearchResults = null;
  },
  SET_CATEGORIES: (state, payload) => {
    state.categories.content = payload;
  },
  SET_SEARCH_RESULTS: (state, payload) => {
    state.pagedSearchResults = payload;
  },
};

const SearchActions: TypedActionTree<ISearchActions, ISearchMutations, ISearchGetters, ISearchState, IRootState> = {
  fetchCategories: async ({ commit }) => {
    //const categories = await searchApiService.getCategories();

    const categories = await searchApiService.filterVisibleCategories();
    commit('SET_CATEGORIES', categories);
  },

  searchDocuments: async ({ commit }, searchQueryParameters) => {
    const searchResult = await searchApiService.searchDocuments(searchQueryParameters);
    commit('SET_SEARCH_RESULTS', searchResult);
  },
};

const SearchGetters: TypedGetterTree<ISearchGetters, ISearchState, IRootState> = {
  categoryWithTerm: (state) => (term) => {
    const subGroups = state.categories.content.reduce(
      (acc, curr) => [...acc, ...curr.children],
      [] as INamedGroup<ICategory>[],
    );
    const allCategories = subGroups.reduce((acc, curr) => [...acc, ...curr.children], [] as ICategory[]);
    return allCategories.find((category) => category.term === term);
  },
  foundDocuments: (state) => state.pagedSearchResults?.documents || [],
};

const SearchState: ISearchState = {
  categories: new LoadableList<IRootCategory>(),
  pagedSearchResults: null,
};

export default new VuexModuleFactory<ISearchState, IRootState, ISearchActions, ISearchMutations, ISearchGetters>(
  'Search',
  SearchState,
  { actions: SearchActions, getters: SearchGetters, mutations: SearchMutations },
);
